import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import moment from 'moment';

export const JWT_COOKIE_NAME = 'jwt';
export const REFRESH_TOKEN_COOKIE_NAME = 'refresh_token';

function getJwtExpiryDate(token: string): Date | undefined {
  try {
    const { exp } = jwtDecode<{ exp?: number }>(token);
    return exp ? moment.unix(exp).toDate() : undefined;
  } catch {
    return undefined;
  }
}

export function getJwtFromCookie(): string | undefined {
  return Cookies.get(JWT_COOKIE_NAME);
}

export function getRefreshTokenFromCookie(): string | undefined {
  return Cookies.get(REFRESH_TOKEN_COOKIE_NAME);
}

export function setJwtCookie(token: string): void {
  Cookies.set(JWT_COOKIE_NAME, token, {
    expires: getJwtExpiryDate(token),
    sameSite: 'lax',
    path: '/',
  });
}

export function setRefreshTokenCookie(token: string): void {
  Cookies.set(REFRESH_TOKEN_COOKIE_NAME, token, {
    expires: getJwtExpiryDate(token),
    sameSite: 'lax',
    path: '/',
  });
}

export function setAuthCookies(accessToken: string, refreshToken: string): void {
  setJwtCookie(accessToken);
  setRefreshTokenCookie(refreshToken);
}

export function removeJwtCookie(): void {
  Cookies.remove(JWT_COOKIE_NAME, { path: '/' });
}

export function removeRefreshTokenCookie(): void {
  Cookies.remove(REFRESH_TOKEN_COOKIE_NAME, { path: '/' });
}

export function clearAuthCookies(): void {
  removeJwtCookie();
  removeRefreshTokenCookie();
}
